// Web Authentication API shim for environments where it's not available
if (typeof window !== 'undefined' && !window.CredentialsContainer) {
  // Create a basic shim for the CredentialsContainer
  window.CredentialsContainer = class CredentialsContainer {
    constructor() {}

    // Add basic stub methods
    async create() {
      console.warn('WebAuthn not supported in this environment');
      return null;
    }
    
    async get() {
      console.warn('WebAuthn not supported in this environment');
      return null;
    }
    
    async store() {
      console.warn('WebAuthn not supported in this environment');
      return undefined;
    }
    
    async preventSilentAccess() {
      console.warn('WebAuthn not supported in this environment');
      return undefined;
    }
  };
}

export {}; 